// Story timeline data mirrored from storylayout.json (kept in src so CRA can bundle it)
export const story = {
  experience: [
    {
      startDate: "Dec 2023",
      endDate: "Present",
      company: "Wipro Technologies Ltd",
      position: "Desktop Support Engineer",
      projectDetails: "HDFC Bank Project | Primus Global Payroll",
      responsibilities: [
        "Resolved high-priority infrastructure incidents using ServiceNow, maintaining strict SLA compliance.",
        "Managed network operations including LAN troubleshooting, DHCP/DNS, and Active Directory user administration.",
        "Administered Windows/Ubuntu servers and performed end-to-end hardware lifecycle management.",
      ],
    },
    {
      startDate: "Jun 2023",
      endDate: "Dec 2023",
      company: "Net Tech Services India Pvt. Ltd",
      position: "Hardware/Technical Support Engineer",
      projectDetails: "Union Bank of India",
      responsibilities: [
        "Diagnosed and resolved complex enterprise hardware and software issues.",
        "Delivered dedicated technical support and client customer service ensuring high end-user satisfaction.",
      ],
    },
    {
      duration: "30 Days Internship",
      company: "Enigmasoft Technologies Pvt. Ltd",
      position: "Full Stack Developer Intern",
      projectDetails: "Café Era Table Booking System",
      responsibilities: [
        "Developed full-stack front-end and back-end logic for the 'Café Era' table booking system.",
      ],
    },
  ],
  projects: [
    {
      name: "Cloud IT Asset Manager",
      url: "https://assetmanagementsystem-hkdfe0dzd9gchkbj.centralindia-01.azurewebsites.net/",
      description:
        "Architected a scalable, role-based cloud database to replace legacy spreadsheet tracking, establishing a single source of truth.",
      technologies: ["MERN", "Azure", "RBAC", "CI/CD"],
    },
    {
      name: "Private Storage Server",
      description:
        "Designed and implemented a centralized 2TB storage server architecture to facilitate seamless data sharing across multiple workstations.",
      technologies: ["Networking", "Hardware", "RAID"],
    },
    {
      name: "Sweet's Paradise (e-commerce)",
      url: "https://khankk4916.wixsite.com/sweetparadise2",
      description:
        "Developing a website for selling online sweets with a dynamic storefront and checkout.",
      technologies: ["Wix", "E-commerce"],
    },
    {
      name: "Café Era (Table booking)",
      url: "https://client-9x38.onrender.com/",
      description: "Full-stack table booking system letting users reserve tables and pick cafe locations.",
      technologies: ["React", "Node.js"],
    },
    {
      name: "Portfolio website",
      url: "https://soheelgadad-portfolio.onrender.com/",
      description: "This portfolio — a self-developed website for personal branding and growth.",
      technologies: ["React", "CSS"],
    },
  ],
  education: [
    {
      startDate: "July 2024",
      endDate: "July 2026",
      degree: "Master of Computer Applications (MCA)",
      institution: "Chandigarh University",
      university: "Chandigarh University",
      specialization: "Cloud Computing & Modern Application Deployment",
      score: "8.65 CGPA",
    },
    {
      endDate: "March 2023",
      degree: "Bachelor of Computer Applications (BCA)",
      institution: "S.P.E. S's Goa Multi-Faculty College",
      university: "Goa University",
      score: "7.74 CGPA",
    },
    {
      endDate: "March 2020",
      degree: "Higher Secondary School Certificate (HSSC)",
      institution: "GVM's SNJA Higher Secondary School",
      board: "Goa Board",
      score: "56%",
    },
    {
      endDate: "April 2018",
      degree: "Secondary School Certificate (SSC)",
      institution: "A.J. De Almeida High School",
      board: "Goa Board",
      score: "41%",
    },
  ],
};